export default __webpack_public_path__ + "static/media/Smart-Biology-LIFE-U2-Cover-Image.28d4c98d.jpg";